import gql from 'graphql-tag'

export const PREMIUM_INVOICE_QUERY = gql`
    query premiumInvoice(
        $id: ID!
    ) {
        premiumInvoice(
            id: $id
        ) {
            id
            file_import_identification_number
            contract_number
            replaced_contract_number
            framework_agreement_number
            invoice_number
            invoice_date
            document_recipient
            customer_first_name
            customer_last_name
            customer_company_name
            files {
                id
                name
                size
                mime_type
                created_at
            }
            positions {
                id
                type
                premium_from
                premium_to
                premium_kind
                premium_type
                sectorCode {
                    id
                    code
                    name
                }
                annual_premium_amount
                instalment_surcharge
                taxes_statutory_charges
                invoiced_amount
            }
            contractMatchShortlist {
                id
            }
            matchedContract {
                id
            }
            matched_contract_confirmed
            created_manually
            created_at
            updated_at
        }
    }
`
